module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('cover-image', {
    attrs: {
      "title": 'Authors',
      "subtitle": 'Meet the people behind the platform',
      "src": 'static/bg-about.jpg'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.authors), function(author) {
    return _c('author-card', {
      key: author,
      staticClass: "col-4 author",
      attrs: {
        "author": author
      }
    })
  }))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e036f39"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/AuthorsView.vue
// module id = 496
// module chunks = 1